// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".work-order-form-comment[data-v-57a4dd20]{font-size:10px}.work-order-form-price-type[data-v-57a4dd20]{width:60px;text-align:left}", ""]);
// Exports
module.exports = exports;
